// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19itglyw{border:none}._19bvze3t{padding-left:var(--ds-space-0,0)}\n._bfhk1j28{background-color:transparent}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._u5f3ze3t{padding-right:var(--ds-space-0,0)}\n._d0altlke:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
